import APP_VERSION from "./version";

const urlParams = new URLSearchParams(window.location.search);
const sid = urlParams.get("sid");
const VIEW_ID_KEY = `viewId_${sid || ""}`;

const createViewId = () =>
	APP_VERSION +
	"-" +
	(window.crypto?.randomUUID
		? window.crypto.randomUUID()
		: Math.random().toString(36).substring(7)) +
	"-" +
	new Date().getTime() +
	(sid ? `;${sid}` : "");

const getViewId = (): string => {
	try {
		const existingViewId = window.localStorage.getItem(VIEW_ID_KEY);
		if (existingViewId) {
			return existingViewId;
		}
	} catch (_) {
		// Localstorage is unavailable
	}

	const newViewId = createViewId();
	try {
		window.localStorage.setItem(VIEW_ID_KEY, newViewId);
	} catch (_) {
		// Localstorage is unavailable
	}
	return newViewId;
};

export const viewId = getViewId();
